import { IDashboardSectionColumn, IDashboardSort, IRowCountCtx } from '../dashboard-metadata.service';
import * as _ from 'underscore';
import { IObject } from '../../../../../type_definitions/datatypes';
import { IReportData, IReportRow } from '../../../../shared/report/report-data.service';
import { DateType } from '../../../../shared/services/date.util';

export const TICKET_SORT:IDashboardSort[] = [
  {
    name: 'Delstbd',
    direction: 'desc'
  },
  {
    name: 'Deagebd',
    direction: 'desc'
  }
];

export const ORDERS_PASSED_SLA_CONFIG: { fixedFilters:IObject; mapping:IObject; sort: IDashboardSort[]; columns:(string|IDashboardSectionColumn)[] } = {
  fixedFilters: {
    Declodt_FROM: DateType.ONE_WEEK_AGO,
    Dedate1: null,
    Dedate2: null,
    Destadt: 1,
    Deestim: 0,
    Totsla_diff: '>0',
    Devendo_cart_show: 1,
    Dependi_show: 1,
    Mainpendingempty: ' is null ',
    Hasslasow: 'exists'
  },
  mapping: {
    Deccoid: 'bp.companyCountryId',
    Decodnm: 'pss.id'
  },
  sort: [
    {
      name: 'Totsla_diff',
      direction: 'desc'
    }
  ],
  columns: [
    {
      name: 'Totsla_diff', //Total Difference SLA
      label: 'Difference SLA'
    },
    'Deordnr', //ACSL#
    'Decounm', //Country
    'Desprnm', //Webshop
    'Decomnm', //BP
    'Devendo', //OEM
    'Decloco', //Closed comment
    {
      name: 'Totsla_days', //Total expected SLA
      label: 'Expected SLA'
    },
    {
      name: 'Totsla_cycle', //Total real SLA
      label: 'Real SLA'
    },
    'Deplato_ds', //Processing mode
    'Deshpcu_ds', //Shipping mode
    'Decodnm', //OD
    'Gblname', //GBDM
    {
      name: 'Derecdt',
      label: 'Date submitted'
    },
    'Declodt', //Date Closed
    'Stocktype'
  ]
};

export const TICKET_KPI_CONFIG:{ mapping:IObject; columns:string[] } = {
  mapping: {
    Deccoid: 'bp.companyCountryId',
    Shsprnm: 'customer.id'
  },
  columns: [
    'Deaddco',
    'Deagebd',
    'Demndid',
    'Delstbd',
    'Dereqid',
    'Orderstatus',
    'Shmtyds',
    'Shdescr',
    'Lsmoddt',
    'Shcommt',
    'Shlslna',
    'Decount',
    'Decnyds',
    'Dfcnyds',
    'Showlna',
    'Shsprnm',
    'Odlname',
    'Shcounm',
    'Shcomnm',
    'Shcdeds',
    'Decredt',
    'Shlname',
    'Shfcomm',
    'Deexpdt',
    'Dereadt',
    'Deurgen_ds',
    'Destads',
    'Shgbdmn',
    'Degamnm',
    'Shlamcm',
    'Shlacom',
    'Shlamcn',
    'Decutds',
    'Rbcomnm',
    'Datefirstreply',
    'Daysfirstreply',
    'Denamnm',
    'Decsunm',
    'Decomds',
    'desk'
  ]
};

export const ORDER_KPI_COLUMNS:string[] = [
  'Devipnr_ds',
  'Dereqid',
  'Depornr', // PO #
  'Dereqst',
  'Decompa',
  'Decounm',
  'Depladt',
  'Desubdt',
  'Decredt',
  'Deveref',
  'Internal_order_nr',
  'Debpref',
  'Debdref',
  'Dedvref',
  'Decommt',
  'Detotal',
  'Actotal',
  'Deetadt',
  'Odlname',
  'Pacomnm',
  'Oddesk',
  'Delamnm',
  'Devendo',
  'Dereqnm',
  'Lacomnm',
  'Stocktype',
  'Delamcn',
  'Decsunm',
  'Decomds',
  'Deenddt',
  'Gblname',
  'Desk',
  'Denamnm',
  'Doityourself_ds',
  'Vnam',
  'Vrep'
];

export const USER_APPROVAL_COLUMNS:string[] = [
  'Deconid',
  'Delname',
  'Defname',
  'Decounm',
  'Decomnm',
  'Desucom',
  'Rbcomnm',
  'Decredt',
  'Deregis',
  'Dedupli_ds',
  'Desprnm'
];

export const SAT_TICKET_COLUMNS = [
  'Deagebd', //Age
  'Demndid', //Ticket #
  'Delstbd', // Days last update
  'Shsprnm', // Webshop
  'Shcounm', // Country
  'Shcomnm', // Company
  'Shlname', // Requested by
  'Showlna', // Owner
  'Decount', // Nr of comments
  'Shdescr', // Subject
  'Dereqid', // ACSL #
  'Shgbdmn', // GBDM
  'Shcommt', // Last comment
  'Shlslna', // Author last comment
  'Dewtyds', // Type
  'Decnyds', // Owner type
  'Dfcnyds', // Default owner type
  'Odlname', // OD
  'Decredt_FROM', // Date created
  'Shlamcn', // LAM contact
  'Shlacom', //LAM
  'Shfcomm', // First comment
  'Shmtyds', //Category
  'Deaddco' // Add comment
];

export const VIP_COLUMNS = [
  'Devipnr_ds', //(!)
  'Deexpdt',    // Expected completion date
  'Dereqid',    // ACSL #
  'Deurgen',    // Urgency
  'Dereqst',    // Order status
  'Deenddt',    // Status date
  'Status_owner', // Status owner
  'Decomds',    // Status detail
  'Deetadt',    // ETA date
  'Desubdt',    // Submit date
  'Decommt',    // Comment
  {
    name: 'Decompa',
    label: 'Company'
  },
  'Decounm',    // Country
  'Pacomnm',    // BP
  'Odlname',    // OD
  'Depladt',    // Placed date
  'Deshpdt',    // Ship date
  'Deveref',    // OEM #
  'Denamnm',    // NAM
  'Doityourself_ds', //DIY
  'Oddesk',      // OD desk
  'Internal_order_nr', // BP internal order number
  'Deurgen_ds', // Urgency
  'Ticket_creation_date', // VIP ticket creation date
  'Ticket_last_update_date', // VIP ticket last update
  'Ticket_description', // VIP ticket description
  'Ticket_last_comment', // VIP ticket last comment
  'Ticket_owner' // VIP ticket owner(s)
];


export const LARGE_QUOTE_KPI:{  fixedFilters: IObject; columns: string[]; sort: IDashboardSort[]; } = {
  fixedFilters: {
    Dewflty_ds: 'PQ',
    Islargeorderorquote: 1
  },
  columns: [
    'Detotal', //Total USD
    'Decharg', // ACSL Fee (ACSL Only)
    'Productcount', // Product count (quote lines #)
    'Orderedquantity', // Total quantity #
    'Devaldt', // Quote validity date
    'Decredt', //Creation date
    'Desprnm', //Customer
    'Decounm', //Country
    'Dereqid', //ACSL #
    'Shstaco', //Status comment short
    'Dereqnm', //Requested by
    'Degbdmn', //GBDM
    'Delamco_ds', //LAM
    'Delamnm', //LAM contact
    'Pacomnm', //BP
    'Decodid_ds', //OD
    'Deavail', //Availability
    'Destatu', //Status
    'Destadt', //Status date
    'Deowner', //Owner
    'Veemail', //Local vendor contact email
    'Quote_type_ds', //Quote type
    'Planned_purchase_date_ds' //Planned purchase date
  ],
  sort: [
    {
      name: 'Decharg',
      direction: 'desc'
    }
  ]
};

export const OPEN_STOCK_ORDERS_KPI: { id: number, fixedFilters: IObject; mapping: IObject; storedReport: string; }  = {
  id: 96,
  fixedFilters: {
    Decalst: 'ALLOPEN',
    Deorddt_FROM: '',
    Deexclo: 1, // exclude closed orders = yes
    Deexclu: 1 // exclude cancel orders = yes
  },
  mapping: {
    Delamco: 'lamCompany.id',
    Desk: 'gbdmDesk.id',
    Gbdm_id: 'gbdm.id'
  },
  storedReport: 'OPEN_STOCK_ORDERS_KPI'
};

export const REPORT_4_MAPPINGS:IObject = {
  Desprnm: 'customer.id',
  Cucomnm: 'customerCompany.id',
  Delamnm: 'lam.id',
  Delamcm: 'lamCompany.id',
  Lagrpnm: 'lamGroup.id',
  Degbdmn: 'gbdm.id',
  Decouid: 'country.id',
  Delamcn: 'lamContact.id',
  Desk: 'gbdmDesk.id'
};

export const HIT_RATE_FIXED_FILTERS:IObject = {
  Excludedemo: 1
};

export const HIT_RATE_MAPPINGS:IObject = {
  Total_months_range: 'totalMonthsRange.id'
};

export const uniqueCountIndicator = (reportData:IReportData, ctx:IRowCountCtx, columnName:string):number => {
  const count:number = _.chain(reportData.data)
    .map(row => row[ columnName ])
    .uniq()
    .value().length;
  return Number(ctx.formattingService.formatNumber(count));
};

export const countryHitRateIndicator = (reportData:IReportData, ctx:IRowCountCtx):string => {
  const count:number = reportData.data.length;
  const countCountriesWithOrders:number = _.chain(reportData.data)
    .filter((row:IReportRow) => row['Detotal'] > 0)
    .value()
    .length;

  const countryHitRatePercentage:string = ctx.formattingService.formatNumber(countCountriesWithOrders / count * 100, '##0') || '0';
  return `${countryHitRatePercentage}% (${countCountriesWithOrders}/${count})`;
};

export const FULL_HEIGHT_GRID: string = '20px;.ui-layout-north;.ui-layout-resizer-north;.profile-selection;.profile-title;.role-selector;.bp-sm .view-overview .nav;h1.dashboard-title';

export const REPORTS_228_220_COLUMNS:string[] = [
  'Devipnr_ds',
  'Dereqid',
  'Depornr', // PO #
  'Decounm',
  'Decredt',
  'Decommt',
  'Pacomnm',
  'Odlname',
  'Detotal',
  'Actotal',
  'Detotal',
  'Dereqst',
  'Decomds',
  'Decompa',
  'Delamnm',
  'Lacomnm',
  'Gblname',
  'Decsunm',
  'Dereqnm', // Order requester
  'Requester_email_address',
  'Stocktype'
];
